import 'css-chunksrc/client/scenes/addIdentityProvider/form/casForm/styles.scss';export default {
  "casForm": "_casForm_1heot_1",
  "group": "_group_1heot_5",
  "checkboxGroup": "_checkboxGroup_1heot_13",
  "label": "_label_1heot_21",
  "checkbox": "_checkbox_1heot_13"
};